import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { isEmpty } from 'lodash-es';

import ThreeDotsIconImage from '../../../assets/svgComponents/ThreeDotsIconImage';

import styles from './Menu.module.scss';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button type="button" ref={ref} className={styles.dropDownButton} onClick={onClick}>
    {children}
  </button>
));

const Menu = ({ items, align }) => (
  <Dropdown>
    <Dropdown.Toggle as={CustomToggle}>
      <ThreeDotsIconImage />
    </Dropdown.Toggle>
    <Dropdown.Menu className={styles.dropdownMenu} align={align ?? 'end'}>
      {items
        .filter((item) => !isEmpty(item))
        .map(({ icon: Icon, isColorPrimary, action, title }) => (
          <Dropdown.Item
            className={isColorPrimary ? `${styles.dropdownItem} ${styles.textBoon}` : styles.dropdownItem}
            onClick={action}
            key={title}
          >
            {Icon && <Icon />}
            {title}
          </Dropdown.Item>
        ))}
    </Dropdown.Menu>
  </Dropdown>
);

export default Menu;
